import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p454734998907453440',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
